import React from 'react';

import strings from '../strings';

import Wrapper from './Layout/Wrapper';
import Row from './Layout/Row';

import Headphones from '../Elements/Icon/assets/headphones.component.svg';
import PlayIcon from '../Elements/Icon/assets/play.component.svg';

const AudioGuideButton = ({ audioguideUrl, language }) => {
    if (!audioguideUrl) {
        return null;
    }

    const onClick = (guide) => {
        window.dispatchEvent(new CustomEvent('audioguide:open', { detail: { guide, expand: true } }));
    };

    return (
        <Row size="medium">
            <Wrapper>
                <button 
                    className="audioguide-button"
                    onClick={() => onClick(audioguideUrl)}
                    data-analytics={ audioguideUrl }
                >
                    <span className="audioguide-button__icon"> 
                        <Headphones />
                    </span>
                    <span className="audioguide-button__text">{strings.AUDIOGUIDE_BUTTON_LABEL[language]}</span>
                    <span className="audioguide-button__play-icon"> 
                        <PlayIcon />
                    </span>
                </button>
            </Wrapper>
        </Row>
    );
}

export default AudioGuideButton;
